import { memo } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { IGracePeriodCpt } from "../../../../models/grace-period-cpt";
import { IGracePeriodCptTableProps } from "./models";
import DisplayDate from "../../../DisplayDate";
import dayjs from "dayjs";
import { Skeleton } from "@mui/material";
import Table from "../../../UI/Table/Table";
import { useTranslation } from "react-i18next";

const TRANSLATION_PATH = "page.beneficiaryGracePeriodCpt.";

export const GracePeriodCptTable = memo(
  ({ data, loading }: IGracePeriodCptTableProps) => {
    const { t } = useTranslation();

    const columns: GridColDef<IGracePeriodCpt>[] = [
      {
        field: "description",
        headerName: `${t(TRANSLATION_PATH + "description")}`,
        flex: 1,
        minWidth: 200,
      },
      {
        field: "unlockDate",
        headerName: `${t(TRANSLATION_PATH + "unlock_date")}`,
        flex: 1,
        maxWidth: 200,
        renderCell: ({ row: { unlockDate } }) => {
          return (
            <DisplayDate format="DD/MM/YYYY">{dayjs(unlockDate)}</DisplayDate>
          );
        },
      },
    ];

    if (loading) {
      return (
        <Skeleton
          variant="rectangular"
          sx={(t) => ({
            mt: 2,
            width: "100%",
            height: 200,
            borderRadius: t.shape.borderRadius,
          })}
        />
      );
    }

    return (
      <Table
        columns={columns}
        rows={data.map((d) => ({ ...d, id: d.integrationId }))}
      />
    );
  }
);
